export enum CanvasRoutes {
  Login = 'Login',

  // Overview app (landing app; its first page is "Home", plus Cycle + Performance)
  Overview = 'Overview',
  OverviewHome = 'OverviewHome',
  OverviewCycle = 'OverviewCycle',
  OverviewPerformance = 'OverviewPerformance',

  // Foundation Forecasting section
  FoundationForecasting = 'FoundationForecasting',
  FoundationForecastingHome = 'FoundationForecastingHome',
  ForecastExplorer = 'ForecastExplorer',

  // Decisions section
  Decisions = 'Decisions',
  DecisionsActivePlanning = 'DecisionsActivePlanning',
  DecisionsBacktests = 'DecisionsBacktests',
  DecisionsBacktestDetail = 'DecisionsBacktestDetail',
  DecisionsExecute = 'DecisionsExecute',
  DecisionsValueOpportunity = 'DecisionsValueOpportunity',
  DecisionsProductStockingLocations = 'DecisionsProductStockingLocations',
  DecisionsCanvas = 'DecisionsCanvas',
  DecisionsPolicies = 'DecisionsPolicies',

  // Data section
  Data = 'Data',
  DataHome = 'DataHome',
  DataCustomers = 'DataCustomers',
  DataProducts = 'DataProducts',
  DataEvents = 'DataEvents',
  DataQuality = 'DataQuality',
  DataTransformations = 'DataTransformations',

  // Explore section
  Explore = 'Explore',
  Search = 'Search',

  // Bonfire section (internal admin tools ported from ksai-smore-bonfire)
  Bonfire = 'Bonfire',
  BonfireSolutions = 'BonfireSolutions',
  BonfireSolutionCreate = 'BonfireSolutionCreate',
  BonfireSolutionDetail = 'BonfireSolutionDetail',
  BonfireSolutionStatusChange = 'BonfireSolutionStatusChange',
  BonfireExecutions = 'BonfireExecutions',
  BonfireExecutionRun = 'BonfireExecutionRun',
  BonfireExecutionDetail = 'BonfireExecutionDetail',
  BonfireModelData = 'BonfireModelData',
  BonfireModelDataForecastQuery = 'BonfireModelDataForecastQuery',
  BonfireModelDataEvaluationQuery = 'BonfireModelDataEvaluationQuery',
  BonfireForecastExplorer = 'BonfireForecastExplorer',
  BonfireLeaderboard = 'BonfireLeaderboard',
}

export interface RouteConfig {
  name: string;
  path: string;
  showInNavigation: boolean;

  // Breadcrumbs
  showInBreadcrumbs: boolean;
  breadcrumb?: string | ((params: Record<string, string>) => string);
  // Optional grouping crumb inserted right after the section root (e.g.
  // "Decisions › Production Optimization › <page>"). Non-navigable label.
  breadcrumbGroup?: string;
  // Keep this route's own crumb in the trail instead of dropping it as the
  // current page (the default). Use when the page heading doesn't already show
  // this route's name (e.g. Backtest Results' heading is just the page itself,
  // but a page passing `extraCrumbs` to replace this crumb, like Value
  // Opportunity, should leave this unset so it gets dropped).
  breadcrumbShowCurrent?: boolean;
}
